export const SET_PAGE_NUMBER = 'numbering/pagination'